
  <div [matTooltip]="!displayPanel ? 'Property & location information' : null"
       matTooltipPosition="right"
       *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.PROPERTIES]">
    <button
        class="mat-icon-toggle-button"
        matIconButton id="properties-manager-toolbar-button" [disabled]="disabled" [class.selected]="displayPanel" type="button" (click)="togglePanelDisplay()">
      <mat-icon>place</mat-icon>
    </button>
  </div>

  <div class="toolbar-panel-container" [hidden]="!displayPanel" *ngIf="!disabled">
    <div class="sidebar-component properties-manager-container">
      <ng-container *ngFor="let infoProperty of infoProperties">
        <mat-card>
          <app-property-location-info
            [infoProperty]="infoProperty"
            [enabledProperties]="enabledProperties"
            [enabledPropertiesReport]="enabledPropertiesReport"
            [reportReady]="viewerService.reportReady$ | async"
            [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
            [defaultVisibilityValues]="defaultVisibilityValues"
            (defaultVisibilityValuesChange)="updateDefaultVisibilityValues($event)"></app-property-location-info>
        </mat-card>
      </ng-container>
      <div *ngIf="!infoProperties?.length" class="no-properties-message">
        <div class="no-result-text">No Search Results</div>
        To gather property information, conduct a search or right click on the map.
      </div>
    </div>
  </div>
